// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"1b5ec464","123":"1c67c042","158":"7c95afc1","624":"1b354d50"}[chunkId] + ".chunk.js";
};